import {
    DeleteImages,
    ImagesFilter,
    InstagramResponse,
    MODULES_OPTIONS,
    PEXELS_FILTER,
    ResourceFilter,
} from '@app/_models/images-manager/images-management.model';

export class GetInstagram {
    public static readonly type = '[ImagesManager] GetInstagram';
}

export class UpdateInstagram {
    public static readonly type = '[ImagesManager] UpdateInstagram';
    constructor(public instagramResponse: InstagramResponse) {}
}

export class SaveInstagramToken {
    public static readonly type = '[ImagesManager] SaveInstagramToken';
    constructor(public token: string) {}
}

export class GetInstagramPhotos {
    public static readonly type = '[ImagesManager] GetInstagramPhotos';
    constructor(public next?: string) {}
}

export class GetImagesList {
    public static readonly type = '[ImagesManager] GetImages';
    constructor() {}
}

export class SetFilters {
    public static readonly type = '[ImagesManager] SetFilters';
    constructor(public filter: ImagesFilter, public isFileUpload?: boolean) {}
}

export class UploadPhoto {
    public static readonly type = '[ImagesManager] UploadPhoto';
    constructor(public payload: FormData, public showToast?: boolean, public isFile?: boolean) {}
}

export class LogoutInstagram {
    public static readonly type = '[ImagesManager] LogoutInstagram';
}

export class ResetUploadedFiles {
    public static readonly type = '[ImagesManager] ResetUploadedFiles';
}

export class ClearInstagramPhotos {
    public static readonly type = '[ImagesManager] ClearInstagramPhotos';
}

export class DeleteImage {
    public static readonly type = '[ImagesManager] DeleteImages';
    constructor(public payload: DeleteImages, public isFileUpload?: boolean) {}
}

export class SetOptimizationConfig {
    public static readonly type = '[ImagesManager] SetOptimizationConfig';
    constructor(public status: boolean) {}
}

export class GetOptimizationConfig {
    public static readonly type = '[ImagesManager] GetOptimizationConfig';
}

export class ClearDeletedImages {
    public static readonly type = '[ImagesManager] ClearDeleteImages';
}

export class GetResourcesConfig {
    public static readonly type = '[ImagesManager] GetResourcesConfig';
    constructor(public payload: ResourceFilter, public module?: MODULES_OPTIONS, public relation_id?: number) {}
}

export class SetPexelsFilter {
    public static readonly type = '[ImagesManager] SetPexelsFilter';
    constructor(public filter: PEXELS_FILTER) {}
}

export class GetPexelsData {
    public static readonly type = '[ImagesManager] GetPexelsData';
    constructor() {}
}

export class GetFilesDocs {
    public static readonly type = '[ImagesManager] GetFilesDocs';
    constructor() {}
}

export class GetFilesDocsSize {
    public static readonly type = '[ImagesManager] GetFilesDocsSize';
    constructor() {}
}

export class DeleteFilesDocs {
    public static readonly type = '[ImagesManager] DeleteFilesDocs';
    constructor(public payload: DeleteImages) {}
}
